import {
  isWebsiteBuilderElement,
  TWebsiteBuilderElement,
  TWebsiteBuilderElementData,
} from "pages/secure/facility/websiteBuilder/editor/nodes/element/websiteBuilderElement";
import { IWebsiteBuilderFooter } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderFooter";
import { IWebsiteBuilderHeader } from "pages/secure/facility/websiteBuilder/editor/nodes/section/websiteBuilderHeader";
import { IWebsiteBuilderRoot } from "pages/secure/facility/websiteBuilder/editor/nodes/root/websiteBuilderRoot";
import { IWebsiteBuilderHistorySnapshot } from "../websiteBuilderEditorAction";
import { IWebsiteBuilderGeneralTraversalNode } from "./generalTraversal";

type TElementTraversalNode = TWebsiteBuilderElement | IWebsiteBuilderGeneralTraversalNode;
type TElementTraversalUpdates = Partial<TWebsiteBuilderElementData>;

function applyUpdates<T extends TWebsiteBuilderElementData>(element: T, updates: TElementTraversalUpdates): T {
  return {
    ...element,
    ...updates,
  };
}

export function elementTraversal(
  header: IWebsiteBuilderHeader,
  root: IWebsiteBuilderRoot,
  footer: IWebsiteBuilderFooter,
  id: string,
  updates: TElementTraversalUpdates,
): IWebsiteBuilderHistorySnapshot {
  function traverse(node: TElementTraversalNode): TElementTraversalNode {
    if (isWebsiteBuilderElement(node)) {
      if (node.id === id) {
        return {
          ...node,
          element: applyUpdates(node.element, updates),
        };
      } else {
        return node;
      }
    } else {
      if (!node.children) {
        return node;
      } else {
        return {
          ...node,
          children: node.children.map(traverse),
        };
      }
    }
  }

  return {
    header: traverse(header) as IWebsiteBuilderHeader,
    root: traverse(root) as IWebsiteBuilderRoot,
    footer: traverse(footer) as IWebsiteBuilderFooter,
  };
}
